import { Modal, Typography } from "antd";
import {
  FileOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import NoteIcon from "../../assets/icons/submitted-note.svg";
import VectorIcon from "../../assets/icons/Submitted-Vector.svg";
import "./QuestionBank.scss";
import CustomButton from "../../components/CustomButton/Button";
import { getJvQuestionDisplay, formatReferenceLinksAnswerForDisplay, isReferenceLinksQuestion } from "../../helpers/jvQuestionnaireAnswers";
import { useState } from "react";

const { Title, Text } = Typography;

const SubmittedQuestionModal = ({
  open,
  onClose,
  selectedQuestion,
}) => {
  const [fileModal, setFileModal] = useState({
    visible: false,
    fileUrl: "",
  });

  if (!selectedQuestion) return null;

  const displayQuestion = getJvQuestionDisplay(selectedQuestion);
  const answerText = selectedQuestion.answers?.[0]?.answerText;
  const displayAnswer = isReferenceLinksQuestion(displayQuestion.questionTitle)
    ? formatReferenceLinksAnswerForDisplay(answerText)
    : answerText;

  const handleFileView = (fileUrl) => {
    if (fileUrl) {
      setFileModal({
        visible: true,
        fileUrl,
      });
    }
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        width={760}
        centered
        closeIcon={<CloseOutlined />}
      >
        <div className="question-modal">
          {/* Header */}
          <div className="modal-header">
            <Title level={3}>
              {displayQuestion.questionTitle}
            </Title>
          </div>

          {/* ADMIN QUESTION */}
          <div className="chat-box admin-box">
            <div className="chat-left">
              <div className="icon-circle admin-icon">
                <img
                  src={NoteIcon}
                  alt="note-icon"
                  width={30}
                  height={30}
                />
              </div>

              <div className="chat-content">
                <div className="chat-top">
                  <Text className="label">
                    Admin Question
                  </Text>

                 
                </div>

                <Text className="message">
                  {displayQuestion.description}
                </Text>
              </div>
            </div>
          </div>

          {/* USER RESPONSE */}
          <div className="chat-box response-box">
            <div className="chat-left">
              <div className="icon-circle response-icon">
                <img
                  src={VectorIcon}
                  alt="note-icon"
                  width={20}
                  height={20}
                />
              </div>

              <div className="chat-content">
                <div className="chat-top">
                  <Text className="label">
                    Your Response
                  </Text>

                 
                </div>

                {selectedQuestion?.answers?.length ===
                  0 ? (
                  <Text className="no-response">
                    No response submitted
                  </Text>
                ) : selectedQuestion.answers[0]
                  ?.answerText ? (
                  <Text className="message response-message" style={{ whiteSpace: "pre-wrap" }}>
                    {displayAnswer}
                  </Text>
                ) : (
                  <CustomButton
                    onClick={() =>
                      handleFileView(
                        selectedQuestion
                          .answers[0]?.fileUrl
                      )
                    }
                  >
                    View file
                  </CustomButton>
                )}

                {selectedQuestion?.file && (
                  <div className="file-box">
                    <FileOutlined />
                    <span>
                      {selectedQuestion.file.name}
                    </span>
                    <Text type="secondary">
                      ({selectedQuestion.file.size})
                    </Text>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* FILE MODAL */}
      <Modal
        open={fileModal.visible}
        onCancel={() =>
          setFileModal({
            visible: false,
            fileUrl: "",
          })
        }
        footer={null}
        width={600}
        centered
      >
        <iframe
          src={fileModal.fileUrl}
          title="Response File"
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
        />
      </Modal>
    </>
  );
};

export default SubmittedQuestionModal;